'use strict';
var BrandAgreementsService = /** @class */ (function () {
    /*@ngInject*/
    function BrandAgreementsService($http, $log, Util, Auth) {
        this.$http = $http;
        this.$log = $log;
        this.handleSuccess = Util.handleSuccess;
        this.handleError = Util.handleError;
        this.Auth = Auth;
    }
    /*@ngInject*/
    BrandAgreementsService.prototype.signBrandAgreementsForBrandCode = function (brandAgreement) {
        this.Auth.clearAccountCache();
        var self = this;
        var agreement = {
            brandCode: brandAgreement.brandCode,
            agree: true
        };
        return this.$http.post('/api/account/brandagreements', agreement)
            .then(function success(response) {
            if (response.status == 200) {
                self.$log.debug('sign brand agreement success response.....', response);
            }
            else {
                self.$log.error('sign brand agreement returned other than 200 response.....', response);
            }
            return response;
        }, function error(response) {
            self.$log.error('sign brand agreement error response.....', response);
            return response;
        });
    };
    /*@ngInject*/
    BrandAgreementsService.prototype.getBrandAgreementsForAccount = function () {
        var request = this.$http({
            method: "get",
            url: "/api/account/brandagreements"
        });
        return (request.then(function (response) {
            return response.data.response;
        }, this.handleError));
    };
    /*@ngInject*/
    BrandAgreementsService.prototype.getAllBrandAgreements = function () {
        var request = this.$http({
            method: "get",
            url: "/api/admin/brandagreements"
        });
        return (request.then(function (response) {
            return response.data.response;
        }, this.handleError));
    };
    return BrandAgreementsService;
}());
export default BrandAgreementsService;
//# sourceMappingURL=brand-agreements.service.js.map